(() => {
  const link = document.querySelector('.sd-skip-link');
  link?.addEventListener('click', () => {
    document.getElementById('MainContent')?.focus({ preventScroll: true });
  });

  // FAQ / collapsible-tab headings are role="button": Minimog only listens for clicks
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const trigger = event.target.closest?.('collapsible-tab [data-trigger][role="button"]');
    if (!trigger) return;
    event.preventDefault();
    trigger.click();
  });
})();
